import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";  
import Slider from "react-slick";
import { useTranslation } from "react-i18next";

const Sectorlist = [
  {
    src: "assets/firstpageimage.webp",  
    name: "content.page1.pageheading",
    route: "/realestate",
  },
  {
    src: "assets/investment-image2.webp",  
    name: "content.page2.pageheading",
    route: "/financial",
  },
  {
    src: "assets/transport-sector-carousal.webp",  
    name: "content.page3.pageheading",
    route: "/transport",
  },
  {
    src: "assets/manufacturing-main-image.webp",  
    name: "content.page4.pageheading",
    route: "/manufacturing",
  },
  {
    src: "assets/education-main-image.webp",  
    name: "content.page5.pageheading",
    route: "/education",
  },
  {
    src: "assets/energy-material-main-image.webp", 
    name: "content.page6.pageheading",
    route: "/energyandmaterial",
  },
  {
    src: "assets/food-main-image.webp",  
    name: "content.page7.pageheading",
    route: "/food",
  },
];

export default function SectorCarousal({removeroute}) {
  const { t } = useTranslation()
  const [slidesToShow, setSlidesToShow] = useState(4);
  const sliderRef = useRef(null);

  let filteredSectorList = Sectorlist.filter((sector) => sector.route !== removeroute);
  filteredSectorList= (document.documentElement.dir==="rtl") ? filteredSectorList.reverse():filteredSectorList;

  useEffect(() => {
    const updateSlidesToShow = () => {
      const width = window.innerWidth;
      if (width >= 1024) {
        setSlidesToShow(4);
      } else if (width >= 768) {
        setSlidesToShow(3);
      } else if (width >= 480) {
        setSlidesToShow(2);
      } else {
        setSlidesToShow(1);
      }
    };

    updateSlidesToShow(); 
    window.addEventListener("resize", updateSlidesToShow); 
    return () => {
      window.removeEventListener("resize", updateSlidesToShow); 
    };
  }, []);

  const settings = {
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: Math.min(slidesToShow, filteredSectorList.length), // Limit scroll count
    infinite: false, // Prevent the slider from looping
    arrows: false,
    centerMode: false,
  };  

  return (
    <div className="w-full flex relative justify-center items-center">
      <div className="w-full max-w-7xl mx-auto py-8 rounded-lg px-4">
        {/* Header and Navigation Buttons */}
        <div className="flex w-full items-center justify-start md:justify-between py-4">
          <div>
            <h1 className="text-4xl">
              <sup>(6)</sup> {t("ourOtherSectors")}
            </h1>
          </div>
          <div className="items-center gap-2 hidden md:flex rtl:flex-row-reverse">
            <div className="py-2">
              <button
                onClick={() => sliderRef.current.slickPrev()}
                className="text-black px-4 py-2 rounded-l-md hover:bg-gray-400"
              >
                <svg
                  width="16"
                  height="28"
                  viewBox="0 0 16 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14 2.18311L2 14.1831L14 26.1831"
                    stroke="#272727"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
            <div className="py-2">
              <button
                onClick={() => sliderRef.current.slickNext()}
                className="text-black px-4 py-2 rounded-r-md hover:bg-gray-400"
              >
                <svg
                  width="16"
                  height="28"
                  viewBox="0 0 16 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2 26.1831L14 14.1831L2 2.18311"
                    stroke="#272727"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* Slider Component */}
        <div className="relative md:w-full rounded-lg overflow-hidden px-2 bg-blue-tint">
          <Slider {...settings} ref={sliderRef} className="bg-blue-tint rounded-lg">
            {filteredSectorList.map((sector, index) => (
              <Link key={index}  to={sector.route} className="hover:text-gray-400 hover:fill-gray-400 text-white">
              <div className="px-2 rounded-lg max-w-80 ">
                {/* Each sector's content */}
                <div className="bg-blue-tint w-full justify-center items-center px-2 py-4 rounded-lg">
                  <img
                    src={sector.src}
                    alt={sector.name}
                    className="w-64 h-72 object-cover mb-4 rounded-lg grayscale hover:grayscale-0"
                  />
                  <h3 className="text-lg flex gap-2 font-normal hover mb-2">
                    <div className="flex justify-between rtl:flex-row-reverse w-full">
                      <span>{t(sector.name)}</span>
                      <svg width="24" height="25" viewBox="0 0 24 25" className="fill-inherit rtl:rotate-180" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.9688 19.4646C12.8991 19.395 12.8437 19.3123 12.806 19.2212C12.7682 19.1302 12.7488 19.0326 12.7488 18.934C12.7488 18.8355 12.7682 18.7379 12.806 18.6468C12.8437 18.5558 12.8991 18.473 12.9688 18.4034L18.4391 12.934L3.74941 12.934C3.5505 12.934 3.35973 12.855 3.21908 12.7143C3.07843 12.5737 2.99941 12.3829 2.99941 12.184C2.99941 11.9851 3.07843 11.7943 3.21908 11.6537C3.35973 11.513 3.5505 11.434 3.74941 11.434H18.4391L12.9688 5.96464C12.8281 5.82391 12.749 5.63303 12.749 5.43401C12.749 5.23499 12.8281 5.04412 12.9688 4.90339C13.1095 4.76266 13.3004 4.68359 13.4994 4.68359C13.6984 4.68359 13.8893 4.76266 14.03 4.90339L20.78 11.6534C20.8498 11.723 20.9051 11.8058 20.9428 11.8968C20.9806 11.9879 21 12.0854 21 12.184C21 12.2826 20.9806 12.3802 20.9428 12.4712C20.9051 12.5623 20.8498 12.645 20.78 12.7146L14.03 19.4646C13.9604 19.5344 13.8777 19.5897 13.7866 19.6274C13.6956 19.6652 13.598 19.6846 13.4994 19.6846C13.4008 19.6846 13.3033 19.6652 13.2122 19.6274C13.1212 19.5897 13.0384 19.5344 12.9688 19.4646Z" fill="white"/>
                      </svg>
                    </div>
                  </h3>
                </div>
              </div>
              </Link>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
}
